import { jsxs as P, jsx as r } from "react/jsx-runtime";
import p from "clsx";
import { C as x, S as E, G as c, p as h } from "./helpers-458d7e27.js";
import { F as L } from "./FeatureColumnItem-4bc31ce0.js";
import { T as O } from "./TextHeaderInner-7887aa3a.js";
import "react";
import "@emotion/react";
import "@paypalcorp/pp-react-theme";
import "@paypalcorp/pp-react-icons";
import "react-dom";
import "./TextGroup-dd19925e.js";
import "./AppDownload-79ac7787.js";
import "./pp-react-text-input.esm-853a9847.js";
import "./card-renderer-3ad4b108.js";
import "./PpReactCurrencyInput-cfa9b61d.js";
import "./TruncatedTextGroup-9d089bba.js";
import "./JumpLinkNavGradient-43d260a5.js";
const b = (o = "Left") => {
  const t = o === "Left";
  return {
    mediaFrame: {
      options: {
        columnStart: "left-outer",
        columnEnd: "right-outer"
      },
      mdOptions: {
        rowStart: 2,
        columnStart: t ? "left-outer" : "mid",
        columnSpan: 3,
        verticalAlign: "center"
      },
      lgOptions: {
        columnStart: t ? "left-outer" : "inner-8",
        columnSpan: 6
      }
    },
    featureItems: {
      mdOptions: {
        rowStart: 2,
        columnStart: t ? "mid" : "left-inner",
        columnEnd: t ? "right-inner" : "mid",
        verticalAlign: "center"
      },
      lgOptions: {
        columnStart: t ? "mid" : "left-inner",
        columnEnd: t ? "right-inner" : "mid"
      }
    }
  };
};
const n = "FeatureColumnSplit", m = new x(n), Q = ({
  collection: o = [],
  mediaFrame: t,
  mediaPosition: s = "Left",
  headline: e,
  disclosureType: l,
  theme: u = "white",
  topSpacer: d = "6vw",
  bottomSpacer: f = "6vw",
  className: g = "",
  componentId: a = n
}) => {
  const S = !!e, C = {
    options: {
      topSpacing: d,
      bottomSpacing: f,
      rowsGap: "value",
      rowsGapValue: "0vw"
    }
  }, i = b(s), w = (e == null ? void 0 : e.bottomSpacer) || "6vw", N = p(
    m.getComponentClassName(),
    g
  ), F = m.getElementClassName("media-container"), I = p(
    m.getElementClassName("features-container"),
    { "grid-2-col": o.length === 4 }
  );
  return /* @__PURE__ */ P(
    E,
    {
      ...C,
      theme: u,
      disclosure: l,
      id: a,
      className: N,
      children: [
        S && /* @__PURE__ */ r(O, { ...e, bottomSpacer: w }),
        /* @__PURE__ */ r(c, { ...i.mediaFrame, className: F, children: /* @__PURE__ */ r(h, { ...t }) }),
        /* @__PURE__ */ r(
          c,
          {
            ...i.featureItems,
            className: I,
            children: o.map((v, G) => /* @__PURE__ */ r(
              L,
              {
                ...v,
                analyticsCompName: n
              },
              `${a}-feature-item-${G + 1}`
            ))
          }
        )
      ]
    }
  );
};
export {
  Q as default
};
//# sourceMappingURL=FeatureColumnSplitSection.js.map
